import {
  enUS as enUSDataGrid,
  esES as esDataGrid,
} from '@mui/x-data-grid/locales';
import {
  enUS as enUSDate,
  esES as esDate, // elGR as elGRDate, Uncomment if Greek lang is going to be used
} from '@mui/x-date-pickers/locales';

import {
  enUS as enUSAdapter,
  es as esAdapter, // el as elAdapter,
} from 'date-fns/locale';

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: { ...enUSDate, ...enUSDataGrid },
    adapterLocale: enUSAdapter,
    icon: 'cif:us',
  },
  {
    label: 'Spanish',
    value: 'es',
    systemValue: { ...esDate, ...esDataGrid },
    adapterLocale: esAdapter,
    icon: 'cif:es',
  },
  // {
  //   label: 'Greek',
  //   value: 'el',
  //   // systemValue: elGRDate,  Uncomment if Greek lang is going to be used
  //   systemValue: enUSDate, // UI text in English
  //   adapterLocale: {
  //     ...elAdapter,
  //     localize: enUSAdapter.localize, // Use English for month/day names
  //     formatLong: elAdapter.formatLong, // Retain Greek format for dates and
  //   },
  //   icon: 'cif:gr',
  // },
];

export const defaultLang = allLangs[0];
